import {
  CORPORATE_DESIGN_SCHEMA,
  DEFAULT_CORPORATE_DESIGN,
  ICorporateDesign,
} from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { IGetGateway, ISaveGateway, IUploadGateway } from '../gateways';

export class CorporateDesignGateway
  implements
    IGetGateway<null, IApiResponse<ICorporateDesign>>,
    ISaveGateway<ICorporateDesign, IApiResponse<ICorporateDesign>>,
    IUploadGateway<FormData, IApiResponse<ICorporateDesign>>
{
  private readonly restCallBuilder: RestCallBuilder<ICorporateDesign> =
    new RestCallBuilder<ICorporateDesign>(DEFAULT_CORPORATE_DESIGN);

  get(): Observable<IApiResponse<ICorporateDesign>> {
    return this.restCallBuilder
      .get('/corporate-design/')
      .validate(
        API_RESPONSE_SCHEMA(CORPORATE_DESIGN_SCHEMA),
        'CorporateDesign.get'
      )
      .handleMessages()
      .build();
  }

  save(query: ICorporateDesign): Observable<IApiResponse<ICorporateDesign>> {
    return this.restCallBuilder
      .post('/corporate-design/', query)
      .validate(
        API_RESPONSE_SCHEMA(CORPORATE_DESIGN_SCHEMA),
        'CorporateDesign.save'
      )
      .handleMessages()
      .build();
  }

  upload(query: FormData): Observable<IApiResponse<ICorporateDesign>> {
    return this.restCallBuilder
      .post('/corporate-design/favicon', query)
      .handleMessages()
      .build();
  }
}
